import http from "./httpService";

const { apiUrl, debug } = window.env;
const apiEndpoint = !debug
  ? apiUrl + "/zipcode/"
  : "https://localhost:44357/ZipCodeService.svc/";

export async function fetchAddress(zipCode, houseNumberFull) {
  if (
    !zipCode ||
    !houseNumberFull ||
    zipCode.length < 6 ||
    houseNumberFull.length < 1 ||
    zipCode.length > 7
  )
    return null;

  let queryString = `?zipCode=${zipCode}&houseNumberFull=${houseNumberFull}`;

  const { IsError: isError, Value: addressValidated } = await http.get(
    apiEndpoint + "FetchAddress" + queryString
  );

  if (isError) return null;

  return addressValidated;
}

export function getZipCodeMask(country) {
  let customMaskZipCode = "9999 aa";

  switch (country) {
    case "BE":
    case "B":
      customMaskZipCode = "9999";
      break;
    case "UK":
      customMaskZipCode = "aa99";
      break;
    case "DE":
    case "D":
      customMaskZipCode = "99999";
      break;
    default:
      break;
  }
  return customMaskZipCode;
}

export default {
  fetchAddress,
  getZipCodeMask
};
